export default __webpack_public_path__ + "static/media/hex_blue.dda3a9bc.svg";